/**
 * Candela — directions dialog.
 *
 * Any element with data-candela-directions="<maps url>" asks first instead of
 * navigating straight out to Google Maps. The confirm is a real link whose
 * href is filled in on open, so the browser treats the hand-off as a genuine
 * user click and no pop-up blocker gets in the way.
 */
(function () {
  var modal = document.getElementById('CandelaDirections');
  if (!modal) return;

  var dialog = modal.querySelector('.candela-directions__dialog');
  var addressEl = modal.querySelector('[data-candela-directions-address]');
  var goEl = modal.querySelector('[data-candela-directions-go]');
  var closeBtn = modal.querySelector('.candela-directions__close');
  var lastTrigger = null;

  function isOpen() {
    return modal.getAttribute('aria-hidden') === 'false';
  }

  function open(trigger) {
    var url = trigger.dataset.candelaDirections;
    if (!url) return;

    lastTrigger = trigger;
    goEl.setAttribute('href', url);
    if (addressEl) addressEl.textContent = trigger.dataset.candelaDirectionsAddress || '';

    modal.setAttribute('aria-hidden', 'false');
    if (window.CandelaScrollLock) window.CandelaScrollLock.update();
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    modal.setAttribute('aria-hidden', 'true');
    if (window.CandelaScrollLock) window.CandelaScrollLock.update();
    if (lastTrigger) lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-candela-directions]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (!isOpen()) return;

    /* The confirm opens in a new tab; close behind it so the page is usable. */
    if (event.target.closest('[data-candela-directions-go]')) {
      close();
      return;
    }

    if (
      event.target.closest('.candela-directions__close') ||
      event.target.closest('[data-candela-directions-cancel]')
    ) {
      close();
      return;
    }

    if (!event.target.closest('.candela-directions__dialog')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) close();
  });

  if (dialog) {
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = dialog.querySelectorAll('button, a[href]');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }
})();
